
import {
  computed, defineComponent,
} from 'vue';

export default defineComponent({
  name: 'SelecionarVariavelDocumentoFiscalEletronico',
  components: {
  },
  props: {
    valor: {
      type: String,
      default: '@NUMERO_DOCUMENTO_FISCAL',
    },
    nfse: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor', 'change'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: string) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor:string) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    function defineValorMarcado(valor:string) {
      emit('change', valor);
    }

    return {
      props,
      computedValor,
      defineValorSelecionado,
      defineValorMarcado,
    };
  },
});
